module.exports = __webpack_public_path__ + "static/img/wzry-companyQualification.ecfeb1d2.png";